// utils/openfund-api.js
export const fetchFundingRounds = async (username) => {
    const url = `https://openfund.com/api/v0/funding-rounds?username=${username}`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching funding rounds:', error);
        return [];
    }
};
